// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  stateMenuChange: true,
};

const actions = {
  changeMenu:
    (stateMenuLocale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve) => {
        if (stateMenuLocale !== undefined) {
          setState({ stateMenuChange: stateMenuLocale });
        }
        resolve(getState());
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'dynamicMenu',
});

export default createHook(Store);
